<script>
</script>

<div class="dropdown-item">
  <slot />
</div>

<style>
  .dropdown-item:not(:first-child) {
    padding-top: 4px;
  }

  .dropdown-item:not(:last-child) {
    padding-bottom: 4px;
  }
</style>
